import React, { useState, useEffect, useRef } from "react"
import "./allBooking.css"
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardTitle,
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { AvField, AvForm } from "availity-reactstrap-validation"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import paginationFactory from "react-bootstrap-table2-paginator"
import logo from "../../assets/images/Logo.png"
import BootstrapTable from "react-bootstrap-table-next"
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter"
import { connect } from "react-redux"
import withRouter from "../../components/Common/withRouter"
import { withTranslation } from "react-i18next"
import moment from "moment"
import BackgroundImage from "../../assets/images/Background.png"
import { postSubmitForm } from "../../helpers/backend_helper"
import showNotification from "../../helpers/show_notificaton"
import preloader from "../../helpers/Loader"


const AllBookings = props => {
  const { SearchBar } = Search

  const [bookings, setBookings] = useState([])
  //Pagination
  const [pageNumber, setPageNumber] = useState(1)
  const [minDateVal, setMinDateVal] = useState("");
  const [maxDateVal, setMaxDateVal] = useState("");
  const [pageSize, setPageSize] = useState(5)
  const [printModal, setPrintModal] = useState()
  const [selectedRow, setselected_Row] = useState()
  const [paymentDetails, setPaymentDetails] = useState()
  const [packageDetails, setPackageDetails] = useState()
  const [fromdate, setFromdate] = useState(new Date())
  const [todate, setTodate] = useState(new Date())
  //Package detail modals
  const [selectedPackageDetails, setSelectedPackageDetails] = useState(null)
  const [isPackageModalOpen, setIsPackageModalOpen] = useState(false)

  //Customer details modal
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false)

  useEffect(() => {
    handleValidSubmit()
  }, [])

  const handleValidSubmit = async () => {
   try {
        preloader(true)
     const payload = {
      date_from: moment(fromdate).format("YYYY-MM-DD"),
      date_to: moment(todate).format("YYYY-MM-DD"),
    }
    let url = process.env.REACT_APP_BASEURL + "bookings/get_datewise"
    const response = await postSubmitForm(url, payload)
    if (response && response.status === 1) {
      const filter = response.data.filter(bkng => (bkng.is_package_only === false || bkng.is_package_only === false))
      setBookings(filter)
      // showNotification(response.message,"Success")
    } else {
      showNotification(response.message, "Error")
    }
   } catch (error) {
    console.log(error);
   } finally {
    preloader(false)
   }
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} - {to} of {size} records.
    </span>
  )

  const options = {
    paginationSize: 10,
    pageStartIndex: 1,
    // hideSizePerPage: true,
    // hidePageListOnlyOnePage: true,
    onPageChange: (page, sizePerPage) => {
      setPageNumber(page)
      setPageSize(sizePerPage)
    },
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: bookings && bookings.length,
      },
    ],
    hideSizePerPage: true,
    ignoreSinglePage: true,
  }

  const handlePackageBadgeClick = packageDetails => {
    setSelectedPackageDetails(packageDetails)
    setIsPackageModalOpen(true)
  }

  const handleViewCustomerDetails = customerDetails => {
    setSelectedCustomer(customerDetails)
    setIsCustomerModalOpen(true)
  }
  // console.log(selectedRow, "SR");
  //Cancel API Call

  function invoiceFormatter(cell, row) {
    return (<>
      {row.booking_status === "Checked out" ? (
        <i
          // className="fa fa-print fs-5 ms-2 " aria-hidden="true"
          style={{ color: "blue", cursor: "pointer" }}
          title={"Print Invoice"}
          disabled={row.booking_status === "Booked" || row.booking_status === "In Process" || row.booking_status === "Cancelled" || row.booking_status === "Completed"}
          onClick={() => {
            setPrintModal(prev => prev = !prev)
            setselected_Row(row)
            setPaymentDetails(row.payment_details)
            setPackageDetails(row.package_details)
          }}
        >{row.invoice_no}
        </i>
      ) : (
        "N/A"
      )}</>
    );
  }
  
const columns = [
  {
    dataField: "_id",
    hidden: true,
  },
  {
    text: "S.N.",
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    headerStyle: { width: "3%", textAlign: "left"  },
  },
  {
    text: "Invoice",
    dataField: "invoice_no",
    formatter: invoiceFormatter,
    sort: true,
    headerStyle: { width: "5%", textAlign: "left"  },
  },
  {
  text: "Customer",
  dataField: "customer_details",
  formatter: (cell, row) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span style={{ fontWeight: 500 }}>{row.customer_details?.name || "N/A"}</span>
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <i
          className="fa fa-info-circle"
          style={{
            fontSize: "14px",
             color: "#556EE6",
            cursor: "pointer",
          }}
          title="Customer Info"
          onClick={() => handleViewCustomerDetails(row.customer_details)}
        ></i>
      </div>
    </div>
  ),
  headerStyle: { width: "15%", textAlign: "left" },
},
  {
    text: "Handled By",
    dataField: "handled_by",
    formatter: (cell, row) => {
      const bookingBy = row.booking_received_by?.name || "-";
      const closedBy = row.booking_closed_by?.name || "-";
      return (
        <div style={{ textAlign: "left",fontSize: "12px" }}>
          <div><strong>Booked:</strong> {bookingBy}</div>
          <div><strong>Closed:</strong> {closedBy}</div>
        </div>
      );
    },
    headerStyle: { width: "15%" },
  },
  {
    text: "Duration",
    dataField: "duration",
    formatter: (cell, row) => {
      const start = row.start_time
        ? moment(row.start_time).format("D MMM YYYY, HH:mm")
        : "-";
      const end = row.end_time
        ? moment(row.end_time).format("D MMM YYYY, HH:mm")
        : "-";
      return (
        <div style={{ textAlign: "left", fontSize: "12px" }}>
          <div><strong>Start:</strong> {start}</div>
          <div><strong>End:</strong> {end}</div>
        </div>
      );
    },
    headerStyle: { width: "18%", textAlign: "left"  },
  },
  {
    text: "Check Status",
    dataField: "check_status",
    formatter: (cell, row) => {
      const checkIn = row.check_in
        ? moment(row.check_in).format("D MMM YYYY, HH:mm")
        : "-";
      const checkOut = row.check_out
        ? moment(row.check_out).format("D MMM YYYY, HH:mm")
        : "-";
      return (
        <div style={{ textAlign: "left" ,fontSize: "12px"}}>
          <div><strong>In:</strong> {checkIn}</div>
          <div><strong>Out:</strong> {checkOut}</div>
        </div>
      );
    },
    headerStyle: { width: "18%", textAlign: "left"  },
  },

  {
    text: props.t("Games"),
    dataField: "game_details",
    formatter: (gameDetails) =>
      gameDetails?.length > 0 ? (
        gameDetails.map((g, i) => (
          <Badge key={i} color="primary" className="me-1">
            {g.game.name}
          </Badge>
        ))
      ) : (
        <Badge style={{ cursor: "not-allowed" }} color="secondary">
          {props.t("No Games")}
        </Badge>
      ),
    headerStyle: { width: "6%", textAlign: "left"  },
  },

  {
    text: props.t("Items"),
    dataField: "item_details",
    formatter: (items) =>
      items?.length > 0 ? (
        items.map((it, i) => (
          <Badge key={i} color="info" className="me-1">
            {it.name}
          </Badge>
        ))
      ) : (
        <Badge style={{ cursor: "not-allowed" }} color="secondary">
          {props.t("No Items")}
        </Badge>
      ),
    headerStyle: { width: "6%", textAlign: "left"  },
  },

  {
    text: props.t("Packages"),
    dataField: "package_details",
    formatter: (packages) =>
      packages?.length > 0 ? (
        packages.map((p, i) => (
          <Badge
            key={i}
            className="glow-effect me-1"
            color="success"
            onClick={() => handlePackageBadgeClick(p)}
          >
            {p.package_name}
          </Badge>
        ))
      ) : (
        <Badge className="cursor-not-allowed" color="secondary">
          {props.t("No Packages")}
        </Badge>
      ),
    headerStyle: { width: "6%", textAlign: "left"  },
  },

  {
    text: "Grand Total",
    dataField: "grand_totall",
    formatter: (cell, row) =>
      row.booking_status !== "Checked out"
        ? row.total_price
        : row.total_amount,
    headerStyle: { width: "6%", textAlign: "left"  },
  },
  {
      dataField: "booking_status",
      text: "Status",
      filter: selectFilter({
        options: [
          { value: "Booked", label: "Booked" },
          { value: "In Process", label: "In Process" },
          { value: "Completed", label: "Completed" },
          { value: "Cancelled", label: "Cancelled" },
          { value: "Checked out", label: "Checked out" },
        ],
        defaultValue: "All",
        placeholder: "ALL",
        style:{height:"20px",padding:'0px 0px 0px 10px',margin:'0px',width:"100px"}
      }),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" }
      },
    },
    {
      dataField: "payment_status",
      text: "Payment Status",
      filter: selectFilter({
        options: [
          { value: "Paid", label: "Paid" },
          { value: "Not Paid", label: "Not Paid" },
        ],
        defaultValue: "Not Paid",
        placeholder: "ALL",
      }),
      hidden: true,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" }
      },
    }
];

  const rowStyle = row => {
    if (row.booking_status === "Completed") {
      return { backgroundColor: "#9873AC" }
    } else if (row.booking_status === "Cancelled") {
      return { backgroundColor: "#ffcdd2" }
    } else if (row.booking_status === "In Process") {
      return { backgroundColor: "#fff9c4" }
    } else if (row.booking_status === "Booked") {
      return { backgroundColor: "#bbdefb" }
    } else if (row.booking_status === "Checked out") {
      return { backgroundColor: "#c8e6c9" }
    }
    return {}
  }

  const expandRow = {
    onlyOneExpanding: true,
    renderer: row => (
      console.log(row.game_details),
      <Card>
        <div className="row "  >
          <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12">
            {/* Games */}
            {row.game_details.length > 0 && (
              <CardBody>
                <div className="table-responsive-sm ">
                  <CardTitle>
                    <h5>{props.t("Games")} </h5>
                  </CardTitle>
                  <table
                    id="example"
                    className="table table-bordered"
                    style={{ width: "100%" }}
                  >
                    <thead className="bg-light">
                      <tr>
                        <th>{props.t("S.N")}</th>
                        <th>{props.t("Game")}</th>
                        <th>{props.t("Duration")}</th>
                        <th>{props.t("Start Time")}</th>
                        <th>{props.t("End Time")}</th>
                        <th>{props.t("Sub Total(QR)")}</th>
                      </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "white" }} >
                      {row?.game_details.map((game, index) =>

                        <tr key={index + 1}>
                          <td>{index + 1}</td>
                          <td>{game?.game.name} &nbsp; ( {game?.table_number} ) </td>
                          <td>{game?.game.duration}  {props.t("minutes")} </td>
                          <td>{game.game?.table_start_time ? moment(game.game.table_start_time).format("HH:mm") : ""}</td>
                          <td>{game.game?.table_end_time ? moment(game.game.table_end_time).format("HH:mm") : ""}</td>
                          <td>{game?.game.sub_total}</td>
                        </tr>

                      )}
                      <tr>
                        <td colSpan={5} style={{ textAlign: "end", fontWeight: "bold" }} >{props.t("Game Total")}</td>
                        <td style={{ fontWeight: "bold" }}>{row.game_total_price || 0}</td>
                      </tr>

                    </tbody>
                  </table>



                </div>
              </CardBody>
            )}

            {/* Items */}
            {row.item_details.length > 0 && (
              <CardBody>
                <div className="table-responsive ">
                  <CardTitle>
                    <h5>{props.t("Items")} </h5>
                  </CardTitle>
                  <table
                    id="example"
                    className="table table-bordered"
                    style={{ width: "100%" }}
                  >
                    <thead className="bg-light">
                      <tr>

                        <th>{props.t("S.N")}</th>
                        <th>{props.t("Item")}</th>
                        <th>{props.t("Section")}</th>
                        <th>{props.t("Quantity")}</th>
                        <th>{props.t("Selling Price")}</th>
                        <th>{props.t("Sub Total(QR)")}</th>

                      </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "white" }}>
                      {row?.item_details.map((item, index) =>

                        <tr key={index + 1} >
                          <td>{index + 1}</td>
                          <td>{item?.name}</td>
                          <td>{item?.section}</td>
                          <td>
                            {item.quantity.in_unit > 0 && item.quantity.in_unit} {item.quantity.in_unit > 0 && item.unit}
                            &nbsp;       {item.quantity.in_sub_unit > 0 && item.quantity.in_sub_unit} {item.quantity.in_sub_unit > 0 && item.sub_unit}
                          </td>
                          {/* <td>{item.quantity?.in_unit} {item.unit} {item.sub_unit !==undefined && item.sub_unit!=="" ? item.quantity.in_sub_unit + " "+ item.sub_unit : ""}</td> */}
                          <td>{item?.price}</td>
                          <td>{item?.sub_total}</td>

                        </tr>

                      )}
                      <tr>
                        <td colSpan={5} style={{ textAlign: "end", fontWeight: "bold" }} >{props.t("Item Total")}</td>
                        <td style={{ fontWeight: "bold" }}>{row.item_total_price || 0}</td>
                      </tr>

                    </tbody>
                  </table>



                </div>
              </CardBody>
            )}

            {/* Packages */}
            {row.package_details.length > 0 && (
              <CardBody>
                <div className="table-responsive ">
                  <CardTitle> <h5>{props.t("Packages")} </h5></CardTitle>
                  <table
                    id="example"
                    className="table table-bordered"
                    style={{ width: "100%" }}
                  >
                    <thead className="bg-light">
                      <tr>

                        <th>{props.t("S.N")}</th>
                        <th>{props.t("Name")}</th>
                        <th>{props.t("Duration/Quantity")}</th>
                        <th>{props.t("Start Time")}</th>
                        <th>{props.t("End Time")}</th>
                      </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "white" }}>
                      {row.package_details && row.package_details[0]?.game_details?.map((item, index) =>

                        <tr key={index + 1} >
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>{item.requested_duration}  {props.t("minutes")}</td>
                          <td>{item?.table_start_time ? moment(item.table_start_time).format("HH:mm") : ""}</td>
                          <td>{item?.table_end_time ? moment(item.table_end_time).format("HH:mm") : ""}</td>
                        </tr>

                      )}

                      {row?.package_details && row?.package_details[0].item_details?.map((item, index) =>

                        <tr key={index + 1} >
                          <td>{row?.package_details[0].game_details.length + index + 1}</td>
                          <td>{item.name}</td>
                          <td>{item.quantity.in_unit} {item.unit} {item.quantity.in_sub_unit} {item.sub_unit}</td>


                        </tr>

                      )}

                    </tbody>
                  </table>



                </div>
              </CardBody>
            )}


          </div>
        </div>
      </Card>
    )
  };

  const backgroundImageStyle = {
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const InfoRow = ({ label, value, condition = true }) => {
  if (!condition || value === undefined || value === null || value === "") return null; // Added checks for undefined, null, and empty string
  return (
    <>
      <div className="col-md-11 col-sm-11 col-11 text-end">
        {label} &nbsp;:
      </div>
      <div  className="col-md-1 col-sm-1 col-1 text-end" style={{ marginLeft: "-14px" }}>
        {value}
      </div>
    </>
  );
};

  return (
    <React.Fragment>
      <div className="page-content" style={backgroundImageStyle}>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title="Bookings"
            alternateTitle="All Bookings"
            breadcrumbItem1="All Bookings"
          />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody
                  style={{
                    background: "linear-gradient(90deg, rgba(0, 40, 80, 1) 5%, rgba(180, 210, 220, 1) 90%)",
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                  }}
                >
                  <AvForm onValidSubmit={handleValidSubmit}>
                    <Row >


<Col lg={3}>
  <label style={{ color: "white" }} className="form-label">
    {props.t("From Date")}
  </label>

  <AvField
    className="form-control"
    type="select"
    tag={Flatpickr}
    value={fromdate ? moment(fromdate).format("YYYY-MM-DD") : ""} 
    options={{
      maxDate: moment().format("YYYY-MM-DD"),
      disableMobile: "true",
      onDayCreate: (dObj, dStr, fp, dayElem) => {
        dayElem.addEventListener('mousedown', (e) => {
          e.preventDefault();
        });
      },
    }}
   onChange={(dates) => {
  const picked = dates[0];
  if (picked) {
    const date = moment(picked);
    setFromdate(date.toDate());

    setMinDateVal(date.format("YYYY-MM-DD"));

    const maxDate = moment.min(date.clone().add(30, "days"), moment());
    setMaxDateVal(maxDate.format("YYYY-MM-DD"));

    if (todate && moment(todate).isAfter(maxDate)) {
      setTodate(null);
    }
  }
}}
    name="date_from"
    placeholder="Select From Date"
    errorMessage="Select From Date."
    validate={{
      required: { value: true },
    }}
  />
</Col>

<Col lg={3}>
  <label style={{ color: "white" }} className="form-label">
    {props.t("To Date")}
  </label>

  <AvField
    className="form-control"
    type="select"
    tag={Flatpickr}
    value={todate ? moment(todate).format("YYYY-MM-DD") : ""} // ✅ safe value
    onChange={(dates) => {
      const picked = dates[0];
      if (picked) {
        const date = moment(picked);
        setTodate(date.toDate());
      }
    }}
    options={{
      minDate: minDateVal,
      maxDate: maxDateVal,
      disableMobile: "true",
      onDayCreate: (dObj, dStr, fp, dayElem) => {
        dayElem.addEventListener('mousedown', (e) => {
          e.preventDefault();
        });
      },
    }}
    name="date_to"
    placeholder="Select To Date"
    errorMessage="Select To Date."
    validate={{
      required: { value: true },
    }}
  />
</Col>



                      <Col lg={2}>
                        <div
                          style={{
                            marginTop: "25px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            type="submit"
                            style={{
                              position: "relative",
                              overflow: "hidden",
                              backgroundColor: "#fdd005",
                              border: "none",
                              color: "black",
                              fontSize: "15px",
                              fontWeight: "500",
                              width: "100px",
                              boxShadow:
                                "rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .4) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px",
                              transition: "transform 0.3s ease",
                            }}
                            onMouseEnter={e => {
                              e.target.style.transform = "scale(1.05)"
                            }}
                            onMouseLeave={e => {
                              e.target.style.transform = "scale(1)"
                            }}
                          >
                            {props.t("Submit")}
                            <div
                              style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                right: "0",
                                bottom: "0",
                                background:
                                  "linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0))",
                                pointerEvents: "none",
                              }}
                            ></div>
                          </Button>
                        </div>
                      </Col>

                    </Row>

                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardBody
                  style={{
                    // overflow:"visible",
                    // height:"2000px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                  }}

                >
                  {/* <CardTitle className="fs-3" >All Bookings</CardTitle> */}

                  <Col>
                    <ToolkitProvider
                      keyField="_id"
                      columns={columns}
                      data={bookings || []}
                      search
                      isGlobalFilter={true}
                      isAddUserList={true}
                      customPageSize={10}
                    >
                      {propst => (
                        <div>
                          <AvForm>
                            <Row>
                              {/* <label className="form-label">
                                {"Search Bookings"}
                              </label> */}
                              <Col lg={2} style={{ display: "flex" }}>
                                <SearchBar
                                  {...propst.searchProps}
                                // style={{ width: "340px" }}
                                />
                              </Col>
                              <Col>
                                {/* <Button className="btn btn-info" onClick={() => { setResetBtnClickedTracker(prev => prev = prev + 1); setFirstTimeApiCall(false); }}  >Reset To Current Month</Button> */}
                              </Col>
                            </Row>
                          </AvForm>
                          <BootstrapTable
                            {...propst.baseProps}
                            filter={filterFactory()}
                            noDataIndication={"No data to display."}
                            // striped
                            condensed
                            pagination={paginationFactory(options)}
                            rowStyle={rowStyle}
                            expandRow={expandRow}

                          // pagination={paginationFactory(options)}
                          />
                          {/* Package Details   */}
                          <Modal
                            isOpen={isPackageModalOpen}
                            toggle={() => setIsPackageModalOpen(false)}
                          >
                            <ModalHeader
                              toggle={() => setIsPackageModalOpen(false)}
                            >
                              {/* Package Details */}
                            </ModalHeader>
                            <ModalBody>
                              {selectedPackageDetails && (
                                <div>
                                  <h5
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      background: "#556ee6",
                                      color: "yellow",
                                      borderRadius: "5px",
                                      height: "50px",
                                      paddingTop: "30px",
                                      paddingBottom: "30px",
                                    }}
                                  >
                                    <h5 style={{ color: "white" }}>
                                      ⟪ {props.t("Package Details")} ⟫
                                    </h5>{" "}
                                    {`Package ID:   
                                    ${selectedPackageDetails.package_id}`}
                                  </h5>

                                  {/* Display other package details here */}

                                  <div className="scrollable-details">
                                    <h5 className="details-heading">
                                      🥤{props.t("Item Details")}:
                                    </h5>
                                    <ul>
                                      {selectedPackageDetails.item_details.map(
                                        (item, index) => (
                                          <li
                                            key={index}
                                            style={{ marginBottom: "0.5rem" }}
                                          >
                                            <div
                                              style={{
                                                marginBottom: "0.25rem",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  fontStyle: "italic",
                                                  fontSize: "15px",
                                                }}
                                              >
                                                {item.name}
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                marginBottom: "0.25rem",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#556ee6",
                                                }}
                                              >
                                                {props.t("Selling Price")}:
                                              </span>
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#fa395d",
                                                }}
                                              >
                                                {item.selling_price}
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                marginBottom: "0.25rem",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#556ee6",
                                                }}
                                              >
                                                {props.t("Cost Price")}:
                                              </span>{" "}
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#fa395d",
                                                }}
                                              >
                                                {item.cost_price}
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                marginBottom: "0.25rem",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#556ee6",
                                                }}
                                              >
                                                {props.t("Section")}:
                                              </span>{" "}
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#fa395d",
                                                }}
                                              >
                                                {" "}
                                                {item.section}
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                marginBottom: "0.25rem",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#556ee6",
                                                }}
                                              >
                                                {props.t("Category")}:
                                              </span>{" "}
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#fa395d",
                                                }}
                                              >
                                                {item.category}
                                              </span>
                                            </div>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </div>
                                  <div className="scrollable-details">
                                    <h5 className="details-heading">
                                      🎮 {props.t("Game Details")}:
                                    </h5>
                                    <ul>
                                      {selectedPackageDetails.game_details.map(
                                        (game, index) => (
                                          <li
                                            key={index}
                                            style={{ marginBottom: "0.5rem" }}
                                          >
                                            <div
                                              style={{
                                                marginBottom: "0.25rem",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  fontStyle: "italic",
                                                  fontSize: "15px",
                                                }}
                                              >
                                                {game.name}
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                marginBottom: "0.25rem",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#556ee6",
                                                }}
                                              >
                                                {props.t("Price")}:
                                              </span>{" "}
                                              <span
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#fa395d",
                                                }}
                                              >
                                                {game.price}
                                              </span>
                                            </div>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </div>
                                  {/* Add more if needed sections for other details */}
                                </div>
                              )}
                            </ModalBody>
                            {/* <ModalFooter>
                              <Button
                                color="secondary"
                                onClick={() => setIsPackageModalOpen(false)}
                              >
                                Close
                              </Button>
                            </ModalFooter> */}
                          </Modal>

                          {/* Customer details Modal */}
                          <Modal
                            style={{ marginTop: "5%" }}
                            isOpen={isCustomerModalOpen}
                            toggle={() => setIsCustomerModalOpen(false)}
                          >
                            <ModalHeader
                              toggle={() => setIsCustomerModalOpen(false)}
                            >
                            </ModalHeader>
                            <ModalBody>
                              {selectedCustomer && (
                                <>
                                  {" "}
                                  <h5
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      background: "#556ee6",
                                      color: "white",
                                      borderRadius: "5px",
                                      height: "20px",
                                      paddingTop: "30px",
                                      paddingBottom: "30px",
                                    }}
                                  >
                                    ⟪ Customer Details ⟫

                                  </h5>{" "}
                                  <br />
                                  <div className="scrollable-details-customer ">
                                    <div style={{ display: "flex", }}>
                                      <h5 className="modal-heading" >
                                        Name:
                                      </h5> &nbsp; &nbsp;
                                      <h5>{selectedCustomer.name}</h5>
                                    </div>
                                    <div style={{ display: "flex", }}>
                                      <h5 className="modal-heading" >
                                        Mobile Number:
                                      </h5> &nbsp; &nbsp;
                                      <h5>{selectedCustomer.mobile}</h5>
                                    </div>
                                    <div style={{ display: "flex", }}>
                                      <h5 className="modal-heading" >
                                        Customer Type:
                                      </h5> &nbsp; &nbsp;
                                      <h5>{selectedCustomer.customer_type}</h5>
                                    </div>



                                    {/* Add more customer details if needed */}
                                  </div>
                                </>
                              )}
                            </ModalBody>
                            <ModalFooter>
                              {/* <Button
                                color="secondary"
                                onClick={() => setIsCustomerModalOpen(false)}
                              >
                                Close
                              </Button> */}
                            </ModalFooter>
                          </Modal>
                        </div>
                      )}
                    </ToolkitProvider>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* Print Receipt */}
        <Row>
          <Col>
            <Modal
              size="xl"
              isOpen={printModal}
              toggle={() => setPrintModal(prev => prev = !prev)}
            >
              <ModalHeader toggle={() => setPrintModal(prev => prev = !prev)} >
              </ModalHeader >
              <ModalBody>
                <div id="printDiv">
                  {/* {selectedRow && ( */}
                  <div className="container pl-4  pr-0">
                    <div className="row head" style={{ backgroundColor: " #f0f0f0", height: "100px", borderRadius: "50px 0px 0px 50px" }}>
                      <div className="col col-md-2 col-sm-2" style={{ display: "flex", justifyContent: "flex-start" }}>
                        <img src={logo} style={{ height: "105px", borderRadius: " 50%", width: "110px", backgroundColor: "#000000" }} />
                      </div>
                      <div className="col col-md-10 col-sm-10 pt-3" style={{ display: "flex", justifyContent: "flex-end" }}>
                        <p className="" style={{ color: "#000000", fontWeight: "500" }}>
                          {selectedRow?.invoice_no} فاتورة رقم<br />
                          {/* PO Id : {selectedRow.po_id}<br /> */}
                          <span style={{ display: "flex", justifyContent: "flex-end", marginTop: "" }}>{moment(selectedRow?.createdAt).format("YYYY-MM-DD HH:mm")} [{selectedRow?.booking_closed_by?.name}] </span>
                          {/* <span style={{ display: "flex", justifyContent: "flex-end", marginTop: "5px" }}></span> */}
                        </p>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div className="row ">
                      <h5> {props.t("Billed To")}</h5>
                    </div>
                    <p className="mb-0 date">
                      <span style={{ fontWeight: 500 }}>
                        {props.t("Name")}: &nbsp;
                        <b> {selectedRow?.customer_details.name}</b>
                      </span>
                    </p>
                    <p className="mb-0">
                      <span style={{ fontWeight: 500 }}>{props.t("Phone")}:</span> &nbsp;
                      <b>{selectedRow?.customer_details.mobile}</b>
                    </p>
                    <p className="mb-0">
                      <span style={{ fontWeight: 500 }}>{props.t("Type")}: </span> &nbsp;
                      <b> {selectedRow?.customer_details.customer_type}</b>
                    </p>
                    <hr />

                    {/* Games */}
                    {selectedRow?.game_details.length > 0 && (
                      <div className="row ">
                        <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                          <div className="table-responsive">
                            <h5>{props.t("Games")}</h5>
                            <table
                              id="example"
                              className="table table-bordered"
                              style={{ width: "100%" }}
                            >
                              <thead className="bg-light">
                                <tr>

                                  <th>{props.t("S.N")}</th>
                                  <th>{props.t("Game")}</th>
                                  <th>{props.t("Table")}</th>
                                  <th>{props.t("Duration")}</th>
                                  <th>{props.t("Start Time")}</th>
                                  <th>{props.t("End Time")}</th>
                                  <th>{props.t("Price")}</th>
                                  <th>{props.t("Sub Total(QR)")}</th>

                                </tr>
                              </thead>
                              <tbody>
                                {selectedRow?.game_details.map((game, index) =>

                                  <tr key={index + 1} >
                                    <td>{index + 1}</td>
                                    <td>{game?.game.name}</td>
                                    <td>{game?.table_number}</td>
                                    <td>{game?.game.duration}  {props.t("minutes")}</td>
                                    <td>{game?.game.table_start_time ? moment(game?.game.table_start_time).format("HH:mm") : ""}</td>
                                    <td>{game?.game.table_end_time ? moment(game?.game.table_end_time).format("HH:mm") : ""}</td>
                                   <td>{selectedRow?.customer_details?.customer_type === "Friend" 
                                          ? game?.game?.price_for_friend 
                                          : game?.game?.customer_details?.customer_type === "Regular" 
                                          ? game?.game?.price_for_regular
                                          : game?.game?.price_for_vip}
                                      </td>
                                    <td>{game?.game.sub_total}</td>

                                  </tr>

                                )}
                                <tr>
                                  <td colSpan={7} style={{ textAlign: "end", fontWeight: "bold" }} >{props.t("Game Total")}</td>
                                  <td style={{ fontWeight: "bold" }}>{selectedRow?.game_total_price || 0}</td>
                                </tr>

                              </tbody>
                            </table>



                          </div>


                        </div>
                      </div>
                    )}


                    {/* Items */}
                    <div className="row ">
                      <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        {selectedRow?.item_details.length > 0 && (
                          <div className="table-responsive">
                            <h5>{props.t("Items ")}</h5>
                            <table
                              id="example"
                              className="table table-bordered"
                              style={{ width: "100%" }}
                            >
                              <thead className="bg-light">
                                <tr>
                                  <th>{props.t("S.N")}</th>
                                  <th>{props.t("Name")}</th>
                                  <th>{props.t("Section")}</th>
                                  <th>{props.t("Quantity")}</th>
                                  <th>{props.t("Selling Price")}</th>
                                  <th>{props.t("Sub Total(QR)")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedRow?.item_details.map((item, index) =>
                                  <tr key={index + 1} >

                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td>{item.section}</td>
                                    <td>
                                      {item.quantity.in_unit > 0 && item.quantity.in_unit} {item.quantity.in_unit > 0 && item.unit}
                                      {item.quantity.in_sub_unit > 0 && item.quantity.in_sub_unit} {item.quantity.in_sub_unit > 0 && item.sub_unit}
                                    </td>
                                    <td>{item.price}</td>
                                    <td>{item.sub_total}</td>
                                  </tr>)}
                                <tr>
                                  <td colSpan={5} style={{ textAlign: "end", fontWeight: "bold" }} >Item Total</td>
                                  <td style={{ fontWeight: "bold" }}>{selectedRow?.item_total_price || 0}</td>
                                </tr>

                              </tbody>
                            </table>


                          </div>
                        )}

                        <hr />

                        {/* Packages */}
                        {packageDetails?.length > 0 && (
                          <div className="row ">
                            <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                              <div className="table-responsive">
                                <h5>{props.t("Packages")} </h5>
                                <table
                                  id="example"
                                  className="table table-bordered"
                                  style={{ width: "100%" }}
                                >
                                  <thead className="bg-light">
                                    <tr>

                                      <th>{props.t("S.N")}</th>
                                      <th>{props.t("Game")}</th>
                                      <th>{props.t("Table")}</th>
                                      <th>{props.t("Duration/Quantity")}</th>
                                      <th>{props.t("Start Time")}</th>
                                      <th>{props.t("End Time")}</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    {packageDetails && packageDetails[0]?.game_details?.map((item, index) =>

                                      <tr key={index + 1} >
                                        <td>#</td>
                                        <td>{item.name}</td>
                                        <td>{item.table_number}</td>
                                        <td>{item.requested_duration}  {props.t("minutes")}</td>
                                        <td>{moment(item.table_start_time).format("HH:mm")}</td>
                                        <td>{moment(item.table_end_time).format("HH:mm")}</td>


                                      </tr>

                                    )}

                                    {packageDetails && packageDetails[0].item_details?.map((item, index) =>

                                      <tr key={index} >
                                        <td>#</td>
                                        <td>{item.name}</td>
                                        <td>{item.quantity?.in_unit} {item.unit} {item.sub_unit !== undefined && item.sub_unit !== "" ? item.quantity.in_sub_unit + item.sub_unit : ""}</td>


                                      </tr>

                                    )}


                                  </tbody>
                                </table>



                              </div>


                            </div>
                          </div>
                        )}
                        <hr />

                     <div
      style={{
        borderTop: "1px dotted #000",
        borderBottom: "1px dotted #000",
        textAlign: "right",
      }}
      className="row"
    >
      {/* Static rows */}
      <InfoRow label="Total Amount" value={selectedRow?.total_amount} />
      <InfoRow
        label="Total Paid"
        value={selectedRow?.paid_amount || selectedRow?.final_amount}
      />

      {/* Conditional rows */}
      <InfoRow
        label="Discount Amount"
        value={selectedRow?.discount_amount}
        condition={selectedRow?.discount_amount > 0}
      />
      <InfoRow
        label="VIP Discount"
        value={selectedRow?.vip_discount}
        condition={selectedRow?.vip_discount > 0}
      />
      <InfoRow label="Change" value={selectedRow?.change_amount} />

      {/* Payment Details */}
      {selectedRow?.payment_details?.map((payment, index) => {
        const { _id, ...details } = payment;
        return Object.entries(details).map(([key, value]) => (
          <InfoRow key={index + key} label={`Paid By ${key}`} value={value} />
        ));
      })}

      {/* Refund */}
      <InfoRow
        label="Refund"
        value={selectedRow?.refund?.refund_amount}
        condition={selectedRow?.refund?.refund_amount > 0}
      />

      {/* Split Details */}
      {selectedRow?.split_details && (
        <>
          <InfoRow
            label={props.t("Split Between")}
            value={selectedRow?.split_details?.split_between}
          />
          <InfoRow
            label={props.t("Amount Per Person")}
            value={selectedRow?.split_details?.amount_per_person}
          />
          <InfoRow
            label={props.t("Extra Amount")}
            value={selectedRow?.split_details?.extra_amount}
            condition={selectedRow?.split_details?.extra_amount > 0}
          />

          {selectedRow?.split_details?.splits?.map((split, i) => (
            <React.Fragment key={i}>
              <div
                className="col-md-11 col-sm-11 col-11"
                style={{
                  marginRight: "20px",
                  padding: "0px",
                  fontWeight: "bold",
                }}
              >
                {props.t("Customer")}: {split?.customer_details?.name} (
                {split?.customer_details?.customer_type})
              </div>

              <InfoRow label={props.t("Paid Amount")} value={split?.paid_amount} />
              <InfoRow label="Change" value={split?.change_amount} />
              <InfoRow
                label={props.t("Discount Amount")}
                value={split?.due_amount}
                condition={split?.due_amount > 0}
              />

              {split?.payment_details?.map((payment, pi) => {
                const { _id, ...details } = payment;
                return Object.entries(details).map(([key, value]) => (
                  <InfoRow
                    key={pi + key}
                    label={`${props.t("Paid By")} ${key}`}
                    value={value}
                  />
                ));
              })}
            </React.Fragment>
          ))}
        </>
      )}
    </div>


                        <div className="row mb-5" style={{ display: "flex", justifyContent: "flex-end" }}>

                        </div>
                      </div>
                    </div>

                  </div>
                  {/* )} */}


                </div>
                <Row className="col text-right pr-5">
                  <Col style={{ display: "flex", justifyContent: "center" }}>
                    <a
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        backgroundColor: "#fdd005",
                        border: "none",
                        marginBottom: "10px",
                        color: "black",
                        fontSize: "15px",
                        fontWeight: "500",
                        width: "190px",
                        boxShadow:
                          "rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .4) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px",
                        transition: "transform 0.3s ease",
                      }}

                      className="btn btn-primary"
                      href={
                        "/invoice_details?booking_id=" + selectedRow?._id
                      }
                      rel="noreferrer"
                      target="_blank"
                    >
                      {props.t("Print")}
                    </a>
                  </Col>
                </Row>
              </ModalBody>
            </Modal>
          </Col>
        </Row>

      </div>
    </React.Fragment>
  )
}

export default withRouter(connect(null, {})(withTranslation()(AllBookings)))
